import { combineReducers } from "@reduxjs/toolkit";

import { reducer as applicantReducer } from "../features/AC/Applicant/applicant.slice";
import { reducer as incidentReducer } from "../features/AC/Incident/incident.slice";
import { reducer as perpetratorReducer } from "../features/AC/Perpetrator/perpetrator.slice";
import { reducer as summaryReducer } from "../features/AC/Summary/summary.slice";
import { reducer as vehicleReducer } from "../features/AC/Vehicle/vehicle.slice";

export const acFormReducer = combineReducers({
  vehicle: vehicleReducer,
  applicant: applicantReducer,
  incident: incidentReducer,
  perpetrator: perpetratorReducer,
  summary: summaryReducer,
});
